import request from "@/utils/request";

// 平台基本信息
//更新平台基本信息
export function getBaseInfo() {
  return request({
    url: `/shop/platform/basic/information`,
    method: "GET",
  });
}

//更新平台基本信息
export function updataBaseInfo(data) {
  return request({
    url: `/shop/platform/basic/information`,
    method: "PUT",
    data: data,
  });
}

//获取平台参数设置
export function getPareamsInfo() {
  return request({
    url: `/shop/platform/parameter/setting`,
    method: "GET",
  });
}

//更新平台参数设置
export function updataPareamsInfo(data) {
  return request({
    url: `/shop/platform/parameter/setting`,
    method: "PUT",
    data: data,
  });
}

//获取平台服务指标列表
export function getIndicatorInfo(type) {
  return request({
    url: `/shop/platform/service/indicator/${type}`,
    method: "GET",
  });
}

//更新平台服务指标列表
export function updateIndicatorInfo(data) {
  return request({
    url: `/shop/platform/service/indicator`,
    method: `${data.id ? "PUT" : "POST"}`, //PUT是更新  POST 是保存
    data: data,
  });
}

//删除平台服务指标列表
export function deleteIndicatorInfo(id) {
  return request({
    url: `/shop/platform/service/indicator/${id}`,
    method: `DELETE`,
  });
}

//获取商品标签
export function getLabelInfo(params) {
  return request({
    url: `/product/sales/shoplabel/ops/getLabelInfo`,
    method: "GET",
    params: params,
  });
}

//审核商品标签
export function checkLabelInfo(data) {
  return request({
    url: `/product/sales/shoplabel/checkLabelInfo`,
    method: "PUT",
    data: data,
  });
}

//保存/更新节假日
export function updateFestivals(data) {
  return request({
    url: `/shop/platform/holidays/festivals`,
    method: `${data.id ? "PUT" : "POST"}`, //PUT更新 POST保存
    data: data,
  });
}

//查询节假日列表
export function queryPlatformHolidaysFestivalsList(data) {
  return request({
    url: `/shop/platform/holidays/festivals/queryPlatformHolidaysFestivalsList`,
    method: "POST",
    data: data,
  });
}

//查询节假日列表
export function delFestivalsById(id) {
  return request({
    url: `/shop/platform/holidays/festivals/${id}`,
    method: "DELETE",
  });
}
